import React from "react";
import { useCurrency } from "../contexts/CurrencyContext";

/**
 * Display-only currency renderer. Accepts an AED amount and shows it in
 * the currency the customer selected via the header switcher. Backend
 * transactions (Stripe, invoicing) always operate in AED regardless.
 *
 * Props
 *   aed        — AED amount (number or numeric string)
 *   decimals   — optional override; defaults to the currency's ISO 4217 minor units
 *   showAedHint— when true and current currency !== AED, appends a subtle
 *                "≈ AED 12,500" caption so cart/checkout stays unambiguous
 *   className  — passthrough for layout
 *   testId     — passthrough for data-testid
 */
export default function Money({ aed, decimals, showAedHint = false, className = "", testId }) {
  const { format, isAED } = useCurrency();
  if (aed == null || aed === "") {
    return <span className={className} data-testid={testId}>—</span>;
  }
  const primary = format(aed, decimals != null ? { decimals } : {});
  const hint = !isAED && showAedHint
    ? ` (≈ AED ${Math.round(Number(aed) || 0).toLocaleString()})`
    : "";
  return (
    <span className={className} data-testid={testId}>
      {primary}
      {hint && <span className="text-white/40 text-[0.85em] ml-1">{hint}</span>}
    </span>
  );
}
